export default __webpack_public_path__ + "static/media/interventional.301398f2.jpg";